import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var addEachKeyValueToObject = function addEachKeyValueToObject(acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
};

export function getFacets(docInfo) {
  if (!docInfo.facets) return {};
  return Object.entries(docInfo.facets).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        facetName = _ref4[0],
        facetValue = _ref4[1];

    return [facetName, [{
      field: facetName,
      data: Object.entries(facetValue).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            value = _ref6[0],
            count = _ref6[1];

        return {
          value: value,
          count: count
        };
      }),
      // Site Search does not support any other type of facet
      type: "value"
    }]];
  }).reduce(addEachKeyValueToObject, {});
}
export function getResults(records, documentType) {
  var isMetaField = function isMetaField(key) {
    return key.startsWith("_");
  };

  var toObjectWithRaw = function toObjectWithRaw(value) {
    return {
      raw: value
    };
  };

  return records[documentType].map(function (record) {
    var highlight = record.highlight,
        sort = record.sort,
        rest = _objectWithoutProperties(record, ["highlight", "sort"]); //eslint-disable-line


    var result = Object.entries(rest).filter(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          fieldName = _ref8[0];

      return !isMetaField(fieldName);
    }).map(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          fieldName = _ref10[0],
          fieldValue = _ref10[1];

      return [fieldName, toObjectWithRaw(fieldValue)];
    }).reduce(addEachKeyValueToObject, {});
    Object.entries(highlight).forEach(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          key = _ref12[0],
          value = _ref12[1];

      result[key].snippet = value;
    });
    return result;
  });
}